import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Button, Col, Row } from "antd";
import WaypointEditTabs, {} from "../waypoint/WaypointEditTabs";
const AddressStep = ({ active, tenantId, isPickup, isCreate, waypoint, onBack, onComplete }) => {
    const waypointEditTabsRef = useRef(null);
    const onNextClicked = () => {
        waypointEditTabsRef.current?.validateFields()
            .then(onComplete)
            .catch(console.error);
    };
    if (!active) {
        return null;
    }
    return (_jsxs("div", { children: [_jsx(WaypointEditTabs, { ref: waypointEditTabsRef, tenantId: tenantId, overwriteAddressOnGeolocate: true, waypoint: waypoint, isCreate: isCreate, isPickup: isPickup, readOnly: false }), _jsx(Row, { children: _jsxs(Col, { xs: 24, children: [_jsx(Button, { type: "default", htmlType: "button", size: "large", onClick: onBack, children: "\u00AB Back" }), _jsx(Button, { type: "primary", htmlType: "button", size: "large", onClick: onNextClicked, className: "pull-right", children: "Next \u00BB" })] }) })] }));
};
export default AddressStep;
